import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import gaEvents from "../../../hooks/gaEvents";
import style from "../LicenseProductsList/LicenseProductsList.module.sass";
import pixelEvent from "../../../hooks/pixelEvent";
import useMakeRequest from "../../../hooks/useMakeRequest";
import moneyBack from "../../../assets/images/icons/moneyBack.svg";
import moneyBackSg from "../../../assets/images/icons/moneyBack_sg.jpg";
import iconKey from "../../../assets/images/icons/icon_key.svg";
import iconKeyDisabled from "../../../assets/images/icons/icon_key_disabled.svg";
import buttonBg from "../../../assets/images/button_small.svg";
import Preloader from "../../../components/UI/Preloader/Preloader";
import PaymentFrame from "../../../components/PaymentFrame/PaymentFrame";
import ModalWindow from "../../../components/UI/ModalWindow/ModalWindow";

function showDays(elem) {
  const obj = {
    "30days": 30,
    "60days": 60,
  };
  if (!obj[elem]) {
    return 0;
  }

  return obj[elem];
}

function is180DaysPassed(timestamp) {
  const days180 = 180 * 24 * 60 * 60 * 1000;
  const date = new Date(timestamp * 1000);
  const now = new Date();

  return now - date >= days180;
}

const LicenseInfo = ({
  userData,
  license,
  licenseExpireTime,
  product,
  moneyBackIcon,
  createdTime,
}) => {
  const [setParams, result, isLoading, hasError, error] = useMakeRequest();
  const [viewLicense, setViewLicense] = useState(false);
  const [licenseState, setLicenseState] = useState(license.state);
  const [openPaymentFrame, setOpenPaymentFrame] = useState(false);
  const [bufferState, setBufferState] = useState("");
  const [openViewModal, setOpenViewModal] = useState(false);

  // Get license
  const [newLicense, setNewLicense] = useState();

  const canViewLicense = () => {
    return (
      license.is_activation_allowed ||
      !is180DaysPassed(license.license_expire_time)
    );
  };

  const handleViewLicenseRequest = (id) => {
    setParams({
      c: "accountStore",
      a: "licenseKey",
      p: { id },
    });
    setViewLicense(true);
    setOpenViewModal(false);
  };

  useEffect(() => {
    if (!error && !hasError && result) {
      setNewLicense(result.license);
      setLicenseState("Active");
    } else if (typeof result === "string") {
      setNewLicense("Delivering, will appear soon here");
    }
  }, [result]);

  const determineStatusLicense = (state) => {
    const obj = {
      Active: "autoRenews",
      Expired: "notSetup",
      "Expired Soon": "expiredSoon",
      Canceled: "canceled",
      "Not activated": "notActivated",
    };
    if (!obj[state]) {
      return obj.Expired;
    }
    return obj[state];
  };

  function getLicenseStatus(state) {
    const obj = {
      Active: "Active until",
      Expired: "Expired on",
      "Expired Soon": "Expires on",
      Canceled: "Canceled on",
      "Not activated": "The license has not been activated",
    };
    if (!obj[state]) {
      return obj.Active;
    }
    return obj[state];
  }

  const onViewLicense = (lic, id, oid, itemName, itemKey) => {
    if (!lic) {
      setOpenViewModal(true);
      return;
    }
    setViewLicense(true);

    gaEvents.viewProductKey(itemName, itemKey, id);
    pixelEvent({
      evt_src: "acct",
      evt_action: "view_license",
      id,
      oid,
      item_name: itemName,
      item_key: itemKey,
      guid: userData.guid,
    });
  };

  // Copy license on click
  const copyLicense = async (lic, id, oid, itemName, itemKey) => {
    navigator.clipboard.writeText(lic).then(() => {
      setBufferState(lic);
      gaEvents.copyProductKey(itemName, itemKey, id);
      pixelEvent({
        evt_src: "acct",
        evt_action: "copy_license",
        id,
        oid,
        item_name: itemName,
        item_key: itemKey,
        guid: userData.guid,
      });
      setParams({
        c: "accountStore",
        a: "addSystemComment",
        p: {
          text: `Customer clicked to view license. | ${id} | ${itemName}`,
          email: userData.email,
        },
      });
    });
  };

  const convertDate = (date) => {
    // The date comes in seconds. Here I cheat on her in milliseconds
    try {
      const dateMs = new Date(date * 1000);
      const formattedDate = new Intl.DateTimeFormat(window.navigator.language)
        .format(dateMs)
        .replace(/\./g, "/");
      return formattedDate;
    } catch (e) {
      console.log(e); // eslint-disable-line no-console
      return "";
    }
  };

  const renderMoneyBack = useCallback((unix, money) => {
    const day = showDays(money);
    const currentDay = Date.now();
    const createdDay = unix * 1000 + 1000 * 60 * 60 * 24 * day;
    const remaingDays = createdDay > currentDay;
    if (remaingDays) {
      return (
        <>
          <img src={moneyBack} alt="moneyBack" />
          <span>
            Eligible for <span>{day}</span>
            -day money back guarantee
          </span>
        </>
      );
    }
    return null;
  }, []);

  // add logic for moneyBackIcon
  function renderSgIcon() {
    return (
      <>
        <img className={style.sgIcon} src={moneyBackSg} alt="moneyBackSg" />
        <span>Security Guarantee Certificate</span>
      </>
    );
  }

  function getCheckoutIcon(type) {
    const obj = {
      sg: () => {
        return renderSgIcon();
      },
      "30days": (data) => {
        return renderMoneyBack(data.createdTime, data.moneyBackIcon);
      },
      "60days": (data) => {
        return renderMoneyBack(data.createdTime, data.moneyBackIcon);
      },
    };
    if (!obj[type]) {
      return () => {};
    }
    return obj[type];
  }

  const renderCheckout = getCheckoutIcon(moneyBackIcon);

  return (
    <div className={style.productLicWrap}>
      <div className={style[determineStatusLicense(licenseState)]}>
        {license.license_dur_days < 3600 ? (
          <>
            {getLicenseStatus(licenseState)}{" "}
            {licenseState !== "Not activated"
              ? convertDate(licenseExpireTime)
              : ""}
          </>
        ) : (
          <>Lifetime</>
        )}
      </div>

      {(licenseState === "Active" || licenseState === "Expired Soon") && (
        <span className={style.moneyBack}>
          {renderCheckout({ createdTime, moneyBackIcon })}
        </span>
      )}
      <div className={style.navigation}>
        {(licenseState === "Active" ||
          licenseState === "Expired" ||
          licenseState === "Expired Soon" ||
          licenseState === "Not activated") && (
          <div
            className={style.keyWrapper}
            style={{
              background: `url(${
                canViewLicense() ? iconKey : iconKeyDisabled
              }) left center no-repeat`,
            }}
            onClick={() => {
              if (!canViewLicense()) {
                return;
              }
              if (!viewLicense) {
                onViewLicense(
                  license.license,
                  license.id,
                  license.oid,
                  product.item_name,
                  product.product_key
                );
                return;
              }
              copyLicense(
                license.license || newLicense,
                license.id,
                license.oid,
                product.item_name,
                product.product_key
              );
            }}
            onKeyUp={() => {
              if (!canViewLicense()) {
                return;
              }
              if (!viewLicense) {
                onViewLicense(
                  license.license,
                  license.id,
                  license.oid,
                  product.item_name,
                  product.product_key
                );
              }
            }}
            role="button"
            tabIndex={0}
          >
            {viewLicense ? (
              <span
                className={
                  window.isSecureContext
                    ? style.key
                    : `${style.key} ${style.key_m}`
                }
                style={{
                  color: `${bufferState && "#3683F7"}`,
                  transition: "0.3s",
                }}
                onKeyUp={() => {
                  if (!canViewLicense()) {
                    return;
                  }
                  onViewLicense(
                    license.license,
                    license.id,
                    license.oid,
                    product.item_name,
                    product.product_key
                  );
                }}
                role="button"
                tabIndex={0}
              >
                {window.isSecureContext && (
                  <div className={style.tooltip}>
                    <span className={style.tooltiptext}>Copy</span>
                  </div>
                )}
                {isLoading ? (
                  <Preloader width="16px" />
                ) : (
                  license.license || newLicense
                )}
              </span>
            ) : (
              <span
                className={`${style.viewKey} ${
                  !canViewLicense() ? style["viewKey--disabled"] : ""
                }`}
              >
                {!canViewLicense() && (
                  <div className={style.tooltip}>
                    <span className={style.tooltiptext}>
                      License expired as the 180-day period passed
                    </span>
                  </div>
                )}
                View product key
              </span>
            )}
          </div>
        )}
        {(licenseState === "Expired" || licenseState === "Expired Soon") && (
          <>
            <PaymentFrame
              frameIsOpen={openPaymentFrame}
              closeFrame={() => {
                setOpenPaymentFrame(false);
              }}
              oid={license.renew.oid}
              licId={license.id}
              prodTitle={product.name_prod}
              licPeriod={product.license_name}
              amount={license.renew.amount}
              prodKey={product.product_key}
              priceType={license.renew.price_key}
              thankYou={license.renew.url_thankyou}
            />
            <div className={style.navigation}>
              <div className={style.renewWrapper}>
                <button
                  className={style.renewButton}
                  onClick={() => {
                    setOpenPaymentFrame(true);
                  }}
                  style={{
                    backgroundImage: `url(${buttonBg})`,
                  }}
                >
                  Renew Now
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <ModalWindow
        isOpen={openViewModal}
        onCancel={() => {
          setOpenViewModal(false);
        }}
        title="Refunds cannot be guaranteed once the digital license key is revealed. Do you wish to proceed?"
        titleClass="modalTitle--normal"
      >
        <div className={style.modal__row}>
          <button
            className={style.modal__button}
            onClick={() => {
              handleViewLicenseRequest(license.id);
            }}
          >
            Yes
          </button>
          <button
            className={style.modal__button}
            onClick={() => {
              setOpenViewModal(false);
            }}
          >
            No
          </button>
        </div>
      </ModalWindow>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
});

const mapDispatchToProps = {};

LicenseInfo.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
  license: PropTypes.objectOf(PropTypes.any),
  product: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.bool,
    ])
  ),
  licenseExpireTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  moneyBackIcon: PropTypes.oneOfType([PropTypes.string]),
  createdTime: PropTypes.oneOfType([PropTypes.number]),
};

LicenseInfo.defaultProps = {
  userData: null,
  license: [],
  product: [],
  licenseExpireTime: null,
  moneyBackIcon: "",
  createdTime: Number,
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenseInfo);
